export default __webpack_public_path__ + "static/media/DSC_7464.24891e43.jpg";